export default __webpack_public_path__ + "static/advent-calendar-72e2941f6657d77b4eb8d0913416ed6f.png";